import React, { useRef, useMemo } from 'react';
import { Avatar } from 'primereact/avatar';
import { Menu } from 'primereact/menu';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuthDispatch, useAuthState } from '../../../context/context';
import { logout } from '../../../context/actions';
import { DisplayProfileImage } from '../../image/displayProfileImage';
import RoleHelper from '../../../utils/roleHelper';

import './headerAuthProfile.css';
import '../../menu/menuSmallPopUp.css';

export const HeaderAuthProfile = (props) => {
    const { t } = useTranslation();
    const dispatch = useAuthDispatch();
    const currentUser = useAuthState();
    const history = useHistory();
    const menu = useRef(null);

    const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId;

    // Handlers
    const handleLogout = () => {
        logout(dispatch);
        const redirectPath = RoleHelper.isEntreprise(currentUser) ? '/entreprise' : '/';
        history.push(redirectPath);
    };

    const handleProfileNavigation = () => {
        if (RoleHelper.isEtudiant(currentUser)) {
            history.push("/profile_student");
        } else if (RoleHelper.isEntreprise(currentUser) || RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname)) {
            history.push({ pathname: '/profile_company', state: { adminImpersonatingRecruteurId } });
        } else {
            history.push("/profile_student");
        }
    };

    // Menu items configuration
    const getProfileLabel = () => {
        if (RoleHelper.isEtudiant(currentUser)) return t('general.myProfile.full');
        if (RoleHelper.isEntreprise(currentUser)) return t('general.myAccount.full');
        return t('general.myProfile.full');
    };

    const menuItems = useMemo(() => {
        const baseItems = {
            profile: {
                label: getProfileLabel(),
                command: handleProfileNavigation
            },
            // CHAT-COMMENTE - à réactiver plus tard
            // messagerie: {
            //     label: t('general.messagerie'),
            //     command: () => history.push("/Messagerie")
            // },
            collaborators: {
                label: t('entreprise.collaborator.my_collaborators'),
                command: () => history.push({ pathname: '/profile_company', hash: "#collaborations", state: { adminImpersonatingRecruteurId } })
            },
            subscriptions: {
                label: t('general.mySubscription'),
                command: () => history.push({ pathname: '/profile_company', hash: "#abonnement", state: { adminImpersonatingRecruteurId } })
            },
            invoices: {
                label: t('general.myInvoices'),
                command: () => history.push({ pathname: '/profile_company', hash: "#factures", state: { adminImpersonatingRecruteurId } })
            },
            disconnect: {
                label: t('general.disconnect'),
                command: handleLogout
            },
            dashboard: {
                label: t('general.dashboard'),
                command: () => history.push("/dashboard")
            },
        };

        // Configuration des menus selon le rôle
        if (RoleHelper.isEtudiant(currentUser) || RoleHelper.isEntreprise(currentUser)) {
            const items = [baseItems.profile];
            
            // Ajout des éléments spécifiques aux entreprises
            if (RoleHelper.isEntreprise(currentUser)) {
                items.push(
                    baseItems.collaborators,
                    baseItems.subscriptions,
                    baseItems.invoices
                );
            }
            
            // baseItems.messagerie, // décommenter quand prêt
            
            // Séparateur avant déconnexion
            items.push(
                { separator: true },
                baseItems.disconnect
            );
            
            return items;
        }

        if (RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname)) {
            return [
                baseItems.dashboard,
                { separator: true },
                baseItems.profile,
                baseItems.collaborators,
                baseItems.subscriptions,
                baseItems.invoices,
                { separator: true },
                baseItems.disconnect
            ];
        }
        
        if (RoleHelper.isAdmin(currentUser)) {
            return [
                baseItems.dashboard,
                { separator: true },
                baseItems.disconnect
            ];
        }

        return [
            baseItems.dashboard,
            { separator: true },
            baseItems.disconnect
        ];
    }, [currentUser, t, history.location.pathname]);

    return (
        <div 
            className={props.className}
            onMouseEnter={(e) => menu.current.show(e)}
            onMouseLeave={() => menu.current.hide()}
        >
            <Menu className="hap-menu-profile-header" model={menuItems} popup ref={menu} />
            <div className={`profile-header-style header-img-profil-etudiant-${props.theme || "iris"}`}>
                {currentUser.user.avatarId ? (
                    <DisplayProfileImage imageId={currentUser.user.avatarId} />
                ) : (
                    <Avatar icon="pi pi-user" size="large" shape="circle" />
                )}
            </div>
        </div>
    );
};